import { dispatchViewAction } from '../dispatcher/AppDispatcher';
import ScrollWidgetConstants from '../constants/ScrollWidgetConstants';

function scrollShopWidget() {
  dispatchViewAction({
    type: ScrollWidgetConstants.SCROLL_WIDGET,
    data: 'shop'
  });
}

export default {
  scrollShopWidget
};
